import * as types from "./types";

export const getPrimaryQuestionnaire = (data) => {
  return {
    type: types.GET_PRIMARY_QUESTIONNAIRE,
    payload: data,
  };
};

export const getQuestionnaireList = (data) => {
  return {
    type: types.GET_QUESTIONNAIRE_LISTING,
    payload: data,
  };
};

export const getQuestionnaireById = (data) => {
  return {
    type: types.GET_QUESTIONNAIRE_BY_ID,
    payload: data,
  };
};

export const setQuestionnaireQuery = (query) => {
  return {
    type: types.SET_QUERY,
    payload: query,
  };
};

export const setQuestionnaireVirtualHeight = (isVirtualHeightNeeded) => {
  return {
    type: types.SET_VIRTUAL_HEIGHT,
    payload: isVirtualHeightNeeded,
  };
};
